import type { ZoomMode } from "./viewerSession";

export const ZOOM_PRESETS = [0.5, 0.75, 1, 1.25, 1.5, 2, 3] as const;

export const FIT_MODES = [
	{ mode: "auto", label: "Automatic" },
	{ mode: "page-width", label: "Fit width" },
	{ mode: "page-fit", label: "Fit page" },
] as const;

const EPSILON = 0.001;

/** The next preset above (`1`) or below (`-1`) the current scale, or none at the end of the range. */
export const nextZoomStep = (scale: number, direction: 1 | -1): number | undefined =>
	direction === 1
		? ZOOM_PRESETS.find((preset) => preset > scale + EPSILON)
		: [...ZOOM_PRESETS].reverse().find((preset) => preset < scale - EPSILON);

export const zoomPercent = (scale: number) => `${Math.round(scale * 100)}%`;

/** pdf.js's `currentScaleValue` takes either a preset name or a number as a string. */
export const toScaleValue = (zoom: ZoomMode) => (typeof zoom === "number" ? String(zoom) : zoom);

export const isFitMode = (zoom: ZoomMode): zoom is Exclude<ZoomMode, number> =>
	typeof zoom !== "number";

export const toZoomMode = (presetValue: unknown, scale: number): ZoomMode =>
	presetValue === "auto" || presetValue === "page-width" || presetValue === "page-fit"
		? presetValue
		: scale;
